import Vue from 'vue';
import { VueMaskDirective } from 'v-mask';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
import router from '@/router';
import '@/assets/scss/main.scss';

import App from './App.vue';

Vue.use(ElementUI, { locale });

Vue.directive('mask', VueMaskDirective);

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
